class d{constructor(r){this.uploadFunc=r}upload(r){return new Promise((a,t)=>{this.uploadFunc(r,({data:u,error:o})=>{o?t(o):a({data:u})})})}}export{d as Uploader};
//# sourceMappingURL=Uploader.js.map
